import { Button, Dialog, Grid, Icon, Typography, Select, Tooltip, FormHelperText } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { Label } from '../../../../../../components/UiElements/UiElements'
import { InputBaseField } from '../../../../../../components/InputField/InputField'
import { PostDataAPI } from '../../../../../../Services/APIService';
import Loader from './../../../../../../components/Loader/Loader';
import { validateEmail, handleNumberKeyPress, validatePhoneNumber, formateMdnNumber } from '../../../../../../../src/components/Common/Extensions';
import { withSnackbar } from "./../../../../../../components/Message/Alert";
import { lstStates, lstCountry, lstMonths } from '../../../../../../../src/components/Common/Lookup';
import axios from 'axios';
import useStyles from "./styles";
function CarrierInformation({ handleNext, triggerProfileInformation, updateTrigger, msisdn, data, isPrepaid, simPrice, setLoaderVisible,
    setLoaderHide, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    data.activationPlanId = data.activationPlanId ? data.activationPlanId.toString() : '';
    const [state, setState] = useState(data);
    const [errorMessages, setErrorMessages] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value,

        }));
    }

    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }

    const handleZipCodeChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
        if (value.trim() != '' && value.trim().length > 4) {
            getStateAndCityOnZipCodeChange(name,value);
        }

    };

    const removeSpacesFromKeys = (obj) => {
        const newObj = {};
        Object.keys(obj).forEach((key) => {
            const newKey = key.replace(/\s/g, '_');
            newObj[newKey] = obj[key];
        });
        return newObj;
    };
    const getStateAndCityOnZipCodeChange = (name,zipCode) => {
        axios
            .get(`https://api.zippopotam.us/us/${zipCode}`)
            .then((response) => {
                if (response.data != null && response.data.places != null && response.data.places.length > 0) {

                    const { state, state_abbreviation, place_name } = removeSpacesFromKeys(response.data.places[0]);
                    if (name == 'shipZip') {
                        setState(prevState => ({
                            ...prevState,
                            ['shipState']: state_abbreviation,
                            ['shipCity']: place_name
                        }))
                    }
                   
                }
            })
            .catch((error) => {
                console.log('Error fetching location data:', error);
            });
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

      const Validate = (errorList) =>
    {
        

        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }

        // if (!state.lastName) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorLastName: true
        //    }));
        //    errorList.push(true);
        // }
        // else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorLastName: false
        //    }));
        // }

   
        if (!state.email || !validateEmail(state.email)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmail: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmail: false
            }));
        }


        if (!state.city) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorCity: false
            }));
        }

        if (!state.phone) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }
          if (state.phone && !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneLength: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneLength: false
            }));
        }

          if (!state.address1) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAddress1: false
            }));
        }

        if (!state.state) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorState: false
            }));
          }
          if (!state.zipCode) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZipCode: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorZipCode: false
            }));
        }

    }

    const SaveProfileInformation = () => {
        debugger
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            handleNext(state)
        }
    }
 

    useEffect(() => {
        console.log(data);
        if (triggerProfileInformation) {
            SaveProfileInformation();
            updateTrigger();
        }
    }, [triggerProfileInformation]);
    
    return (
        <>

            <Grid container alignItems='center'>
                <Grid item lg={12} sm={12} xs={12}>
                    <Grid container>
                        <div className={classes.dialogSubHeader}>
                            <h3>Profile Information</h3>
                        </div>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container>
        
{/* 
                <Grid container spacing={2}>
                    <h4 className={classes.secHeading}>Shipping Information  </h4>
                </Grid> */}

                <Grid lg={12} sm={12} xs={12}>
                    <Grid container spacing={window.isMobileView? 0:    4}>
                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label size={12} title="First Name" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="firstName"
                                    name="firstName"
                                    type="text"
                                    value={state.firstName}
                                    onChange={handleChange}
                                    placeholder='First Name'
                                    IsDisabled={false}
                                    MaxLength='50'
                                />
                                {errorMessages.errorFirstName && !state.firstName ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter first name
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label size={12} title="Last Name" />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="lastName"
                                    name="lastName"
                                    type="text"
                                    value={state.lastName}
                                    onChange={handleChange}
                                    placeholder='Last Name'
                                    IsDisabled={false}
                                    MaxLength='50'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Label size={12} title="Address" mandatory={true} />
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <InputBaseField
                                id="address1"
                                name="address1"
                                type="text"
                                value={state.address1}
                                onChange={handleChange}
                                placeholder='Address'
                                IsDisabled={false}
                                MaxLength='80'
                            />
                            {errorMessages.errorAddress1 && !state.address1 ? (<FormHelperText style={{ color: "red" }} >
                                Please enter shipping address
                            </FormHelperText>) : ('')}
                        </Grid>
                    </Grid>
                    <Grid container spacing={window.isMobileView? 0:    4}>
                        <Grid item sm={12} xs={12} md={4} lg={4} xl={4} >
                            <Label size={12} title="City" mandatory={true}  />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="city"
                                    name="city"
                                    type="text"
                                    value={state.city}
                                    onChange={handleChange}
                                    placeholder='City'
                                    IsDisabled={false}
                                    MaxLength='50'
                                />
                                {errorMessages.errorCity && !state.city ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter city
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={4} lg={4} xl={4} >
                            <Label size={12} title="State" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >

                                <Select
                                    size="small"
                                    native
                                    name="state"
                                    value={state.state}
                                    onChange={handleSelectChange}
                                    // autoComplete="off"
                                    placeholder="Select"
                                    label="Select"
                                    className={classes.selectBaseInput}
                                >
                                    {lstStates.map(option =>
                                        <option value={option.value}>{option.label}</option>
                                    )
                                    }
                                </Select>
                                {errorMessages.errorState && !state.state ? (<FormHelperText style={{ color: "red" }} >
                                    Please select state
                                </FormHelperText>) : ('')}
                                
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={4} lg={4} xl={4} >
                            <Label size={12} title="ZIP / Postal Code" mandatory={true} />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="zipCode"
                                    name="zipCode"
                                    type="text"
                                    value={state.zipCode}
                                    onChange={handleZipCodeChange}
                                    placeholder='ZIP / Postal Code'
                                    IsDisabled={false}
                                    MaxLength='5'
                                    onKeyPress={(e) => handleNumberKeyPress(e)}
                                />
                                {errorMessages.errorZipCode && !state.zipCode ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter ZIP / Postal Code
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container spacing={window.isMobileView? 0:    4}>
                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label size={12} title="Email" mandatory={true}  />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="email"
                                    name="email"
                                    type="text"
                                    value={state.email}
                                    onChange={handleChange}
                                    placeholder='Email'
                                    IsDisabled={false}
                                    MaxLength='80'
                                />
                                {errorMessages.errorEmail && (!state.email || !validateEmail(state.email)) ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter a valid email address
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>
                        <Grid item sm={12} xs={12} md={6} lg={6} xl={6} >
                            <Label size={12} title="Phone #" mandatory={true}  />
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <InputBaseField
                                    id="phone"
                                    name="phone"
                                    type="text"
                                    value={state?.phone}
                                    onChange={handlePhoneChange}
                                    placeholder='Phone #'
                                    IsDisabled={false}
                                    MaxLength={14}
                                />
                                {errorMessages.errorPhone && (!state.phone ) ? (<FormHelperText style={{ color: "red" }} >
                                    Please enter phone number
                                </FormHelperText>) : ('')}
                                {errorMessages.errorPhoneLength && (state.phone || !validatePhoneNumber(state.phone)) ? (<FormHelperText style={{ color: "red" }} >
                                    please enter valid phone number
                                </FormHelperText>) : ('')}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>







            </Grid>
        </>
    )
}
export default withSnackbar(CarrierInformation);
